













































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import '@/compiled-icons/info-outline';
import SelectEvent from '@/types/selectEvent';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {get} from 'lodash';
import {DisguiseBusinessExceptionWrapper} from '../../exception/disguise-business-exception-wrapper';
import {AMETRAS_PARAM_UTILS} from '@/utils/params.utils';
import {CompositeKeyType} from '@/interfaces/key.interface';
import {AxiosResponse} from 'axios';
import {SubMenuConfig} from '@/interfaces/submenu.interface';
import {FormularCloseEventData} from '@/views/formular/form.interface';
import SubMenuTemplate from '@/views/SubMenuTemplate.vue';
import {ICONS_SERVICE_INSTANCE} from '@/utils/icons.service';

interface FormularConfig {
  '@type': 'FORMULAR';
  templateUrl: string;
  entityUrl: string;
  formTitle: string;
  create: boolean;
  primaryKey: CompositeKeyType;
  onClose: (formConfig: FormularConfig, eventData?: FormularCloseEventData) => void;
  onSave: (formConfig: FormularConfig, response: AxiosResponse) => void;
  overwrittenFields?: { [fieldName: string]: DisguiseDto.FTFieldDto };
}

type DynamicContentUnion = FormularConfig;

export interface AmetrasArticleInfoReplacementEventData {
  title: string;
  urlParameters: DisguiseDto.DTUrlParameterDto[];
  urlBase: string;
  actionType?: DisguiseDto.EnumButton;
}

interface ArticleReplacementDialogType {
  dialogTitle?: string;
  maxWidthInPx?: number;
  widthPercentage?: number;
  content: DynamicContentUnion;
}

interface ArticleReplacementSubMenuConfig extends SubMenuConfig {
  actionConfiguration?: DisguiseDto.DTActionConfigurationUnion;
}

/**
 * General Component for Fields of type Article Replacement
 */
@Component({
  name: 'ametras-article-info-replacement-template',
  components: {
    SubMenuTemplate,
    FormTemplate: () => import('@/views/formular/FormTemplate.vue'),
    DataTableTemplate: () => import('@/views/datatable/DataTableTemplate.vue')
  }
})
export default class AmetrasArticleInfoReplacementTemplate extends Vue {
  @Prop() marginDefinition!: string;
  @Prop() paddingDefinition!: string;
  @Prop() object!: DisguiseDto.QuantityTriggerOutputDto;
  dialogOpen: boolean = false;
  dtUrl: string = '';
  subMenu: ArticleReplacementSubMenuConfig | null = null;
  showDialog: boolean = false;
  dialog: ArticleReplacementDialogType | null = null;
  expanded: boolean = true;
  iconsService = ICONS_SERVICE_INSTANCE;

  toggle() {
    this.expanded = !this.expanded;
  }

  getCustomIconStyle(isExpanded: boolean) {
    let result: { [key: string]: string | string[] } = {};
    if (isExpanded) {
      result = {
        ...result,
        transform: 'rotate(180deg)'
      };
    }
    return result;
  }

  invoiceInfo() {
    const urlParams: DisguiseDto.DTUrlParameterDto[] = [];
    urlParams.push({
      parameter: 'hlk',
      value: this.object.hlk
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'formattedArticleNo',
      value: this.object.formattedArticleNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'customerNo',
      value: this.object.customerNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'companyNo',
      value: this.object.companyNo
    } as DisguiseDto.DTUrlParameterDto);

    const invoiceInfos: AmetrasArticleInfoReplacementEventData = {
      title: 'Fakturainfos',
      urlParameters: urlParams,
      urlBase: this.object.invoiceInfoUrlBase || '',
    };

    this.replacementDialogAction(invoiceInfos);
  }

  openPriceScheme() {
    const orderInfo: AmetrasArticleInfoReplacementEventData = {
      title: 'Preisschema',
      urlParameters: [],
      urlBase: this.object.pricingSchemeUrl || '',
    };

    this.replacementDialogAction(orderInfo);
  }

  openOffers() {
    const urlParams: DisguiseDto.DTUrlParameterDto[] = [];
    urlParams.push({
      parameter: 'hlk',
      value: this.object.hlk
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'formattedArticleNo',
      value: this.object.formattedArticleNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'customerNo',
      value: this.object.customerNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'companyNo',
      value: this.object.companyNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'searchOffer',
      value: 'true'
    } as DisguiseDto.DTUrlParameterDto);

    const orderInfo: AmetrasArticleInfoReplacementEventData = {
      title: 'Angebote',
      urlParameters: urlParams,
      urlBase: this.object.showOrderPositionsUrl || '',
    };

    this.replacementDialogAction(orderInfo);
  }

  openOrders() {
    const urlParams: DisguiseDto.DTUrlParameterDto[] = [];
    urlParams.push({
      parameter: 'hlk',
      value: this.object.hlk
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'formattedArticleNo',
      value: this.object.formattedArticleNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'customerNo',
      value: this.object.customerNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'companyNo',
      value: this.object.companyNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'searchOffer',
      value: 'false'
    } as DisguiseDto.DTUrlParameterDto);

    const orderInfo: AmetrasArticleInfoReplacementEventData = {
      title: 'Aufträge',
      urlParameters: urlParams,
      urlBase: this.object.showOrderPositionsUrl || '',
    };

    this.replacementDialogAction(orderInfo);
  }

  openAdditionalTexts() {
    const urlParams: DisguiseDto.DTUrlParameterDto[] = [];
    urlParams.push({
      parameter: 'companyNo',
      value: this.object.articlesCompanyNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'hlk',
      value: this.object.hlk
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'warehouseNoArticleStock',
      value: this.object.wareHouseNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'formattedArticleNo',
      value: this.object.formattedArticleNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'companyNoArticleStock',
      value: this.object.companyNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'companyNoCompanyMasterdata',
      value: this.object.companyNo
    } as DisguiseDto.DTUrlParameterDto);

    const additionalText: AmetrasArticleInfoReplacementEventData = {
      title: 'Artikelinformationen',
      urlParameters: urlParams,
      urlBase: this.object.articleInfoTextUrlBase || '',
      actionType: 'OPENSUBMENU'
    };
    this.replacementDialogAction(additionalText);
  }

  search(selectEvent: SelectEvent) {
    let replacementArticleHlk = '';
    let replacementArticleNo = '';
    for (const param of selectEvent.params) {
      if (param.parameter === 'replacementArticleHlk') {
        replacementArticleHlk = param.value || '';
      }
      if (param.parameter === 'replacementFormattedArticleNo') {
        replacementArticleNo = param.value || '';
      }
    }
    let searchUrl = selectEvent.baseUrl;
    searchUrl += '&companyNo=' + this.object.companyNo;
    searchUrl += '&wareHouseNo=' + this.object.wareHouseNo;
    searchUrl += '&hlk=' + replacementArticleHlk;
    searchUrl += '&formattedArticleNo=' + replacementArticleNo;

    HTTP_SERVICE_INSTANCE.getAxios().get(searchUrl).then((response) => {
      this.object.actualAmountAvailable = get(response, 'actualAmountAvailable');
      this.object.replacementArticleHlk = replacementArticleHlk;
      this.object.replacementArticleNo = replacementArticleNo;
      this.dialogOpen = false;
    }, (error: any) => {
      if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
        this.$store.commit('showSnack', {
          message: 'Übernahme fehlgeschlagen',
          color: 'error'
        });
      }
    });
  }

  showHistory() {
    this.dtUrl = this.object.replacementArticleUrlBase || '';
    this.dtUrl += '&companyNo=' + this.object.articlesCompanyNo;
    this.dtUrl += '&formattedArticleNo=' + this.object.formattedArticleNo;
    this.dtUrl += '&hlk=' + this.object.hlk;
    this.dialogOpen = true;
  }

  showArticleInfo(clickEvent: any) {
    const urlParams: DisguiseDto.DTUrlParameterDto[] = [];
    urlParams.push({
      parameter: 'companyNo',
      value: this.object.articlesCompanyNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'hlk',
      value: this.object.replacementArticleHlk
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'warehouseNoArticleStock',
      value: this.object.wareHouseNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'formattedArticleNo',
      value: this.object.replacementArticleNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'companyNoArticleStock',
      value: this.object.companyNo
    } as DisguiseDto.DTUrlParameterDto);
    urlParams.push({
      parameter: 'companyNoCompanyMasterdata',
      value: this.object.companyNo
    } as DisguiseDto.DTUrlParameterDto);

    const articleInfo: AmetrasArticleInfoReplacementEventData = {
      title: 'Artikelinformationen',
      urlParameters: urlParams,
      urlBase: this.object.articleInfoUrlBase || '',
      actionType: 'OPENSUBMENU'
    };

    this.replacementDialogAction(articleInfo);
  }

  applyReplacementArticle() {
    this.$emit('applyReplacementArticle', this.object);
  }

  replacementDialogAction(action: AmetrasArticleInfoReplacementEventData) {
    if (action.actionType && action.actionType === 'OPENSUBMENU') {
        this.subMenu = {
          url: action.urlBase || '',
          contextParameter: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
          title: action.title || '',
          breadcrumbs: [],
          attachLocally: false
        };
    } else {
      // the current default if not OPENSUBMENU is opening a dialog
      this.showDialog = true;
      this.dialog = {
        dialogTitle: action.title || '',
        content: {
          ['@type']: 'FORMULAR',
          onClose: () => undefined,
          onSave: () => undefined,
          templateUrl: action.urlBase || '',
          entityUrl: '',
          primaryKey: AMETRAS_PARAM_UTILS.convertParamListToCompositeKey(action.urlParameters),
          formTitle: action.title || '',
          create: false
        }
      };
    }
  }

  closeDialog() {
    this.dialog = null;
    this.showDialog = false;
  }

  /* Workaround for closing the menus without using v-model. */
  closeSubmenuDialog() {
    this.subMenu = null;
  }
}
